/** Full-width comment placeholder for conversation loading screens. */

import { Pad } from 'component/basics';
import { Fragment } from 'react';
import { StyleSheet, View } from 'react-native';

import { BaseSkeleton } from './base-skeleton';
import { TextContainerSkeleton } from './text-container-skeleton';

export type CommentSkeletonProps = { variant: 'mobile' | 'desktop' };

// Comment placeholder with a configurable number of body lines. The last
// line is rendered short to mimic a real paragraph's ragged final line.
export function CommentSkeleton({ variant }: CommentSkeletonProps) {
    const s = CommentSkeletonStyle;
    const isMobile = variant === 'mobile';
    const lines = isMobile ? 2 : 4;
    const bodyBorderRadius = isMobile ? 4 : 2;
    return (
        <View style={s.container}>
            <View style={s.byline}>
                <BaseSkeleton borderRadius={16} height={32} marginRight={8} width={32} />
                <TextContainerSkeleton borderRadius={2} height={6} width={100} />
            </View>
            <View style={s.body}>
                {Array.from({ length: lines }).map((_, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Fragment key={i}>
                        {i > 0 && <Pad size={12} />}
                        <TextContainerSkeleton borderRadius={bodyBorderRadius} height={6} width={i === lines - 1 ? 140 : undefined} />
                    </Fragment>
                ))}
            </View>
        </View>
    );
}

const CommentSkeletonStyle = StyleSheet.create({
    container: { paddingVertical: 20, width: '100%' },
    byline: { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 20, marginBottom: 20 },
    body: { paddingLeft: 60, paddingRight: 20 },
});
